<template lang="pug">
	.launchContainer
</template>

<style lang="scss" scoped>
	//
</style>

<script>
	import { mapGetters } from "vuex";
	import { getInstance } from "@/auth";

	export default {
		data() {
			return {};
		},
		computed: {
			...mapGetters(["loggedIn"])
		},
		methods: {
			// https://stackoverflow.com/questions/60302944/auth0-client-is-null-in-vue-spa-on-page-refresh
			init(fn) {
				const instance = getInstance();
				instance.$watch("loading", (loading) => {
					if (loading === false) {
						fn(instance);
					}
				});
				if (!instance.loading) {
					fn(instance);
				}
			}
		},
		created() {
			this.init(() => {
				const instance = getInstance();
				if (this.loggedIn && !instance.isAuthenticated) {
					// Localhost says user is logged in but Auth0 says the opposite, so log the user out
					this.$store.dispatch("logout");
				}
			});
		}
	};
</script>
